import gql from 'graphql-tag';
import {PriceDetailsWrapperFragment} from '../PriceDetailsWrapper/PriceDetailsWrapperFragment';
export const ConfirmationQuery = gql`
    query confirmationQuery ($reservationId: String!, $unitLink: String!) {
        bookingConfirmation(
            reservationId: $reservationId,
            unitLink: $unitLink
        ) {
            edapAnalyticsPayload{
                fullorderrentalrate
                bidTarget
                egTrueValueAmountLocal
                eg_true_value_amount_usd: egTrueValueAmountUsd
                currency
                eventstartdate
                eventenddate
                lengthofstay
                numadults
                numchildren
                withpets
                booking_window: bookingwindow
                book_date: bookDate
                displaycurrency
                displayquotetotal
                latitude
                listing_id:listingid
                longitude
                propertytype
                partnerfeesamount
                geoname
                lbsuuid
                admin1
                locality
                country
            }
            bookingSummary {
                instantBooking
                localizedArrivalTime
                localizedCheckinDate
                checkinDate
                localizedCheckoutDate
                checkoutDate
                localizedDepartureTime
                numAdults
                numChildren
                numPets
                reservationReferenceNumber
                reservationStatus
                travelerEmail
            }
            ctaDetails {
                addGuestLink
                ctaLink
            }
            krazyGlueUrl
            listing {
                contact {
                    name
                }
                detailPageUrl
                geography {
                    description
                }
                images {
                    uri
                }
                integratedPropertyManager
                platformPropertyManager
                ownerManaged
                propertyId
                lodgingDirectoryId
                isSubscription
                payPerBooking
                instantBookable
                onlineBookable
                acceptsHomeAwayPayments
                isCrossSell
                isBasicListing
            }
            priceDetails{
                failedInsurtechItems {
                    title
                    status
                    vasPaymentDetails {
                        type
                    }
                }
            }
            paymentConfirmation
            valueAddedServicesSummary {
                vascartUrl
            }
        }
        ecomPriceDetails (
            reservationId: $reservationId,
        ) {
            ${PriceDetailsWrapperFragment}
        }
    }
`;
